import styled from 'styled-components';

const LearningActiviesStyle = styled.div`
    .user-title-container{
        text-align: left;
    }
    .user-menu-title{
        font-size: 1.424rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
        word-break: break-word;
        hyphens: auto;
        text-align: left;
        margin-bottom: 10px;
    }
    .users-menu-filter-container{
        display: flex;
        align-items: center;
        gap: 18px;
    }
    .search-input-field{
        margin-bottom: 0px !important;
        input{
            margin-bottom: 0px;
        }
    }

    .download_csv_con{
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        font-size: 22px;
        width: 30px;
        height: 30px;
        background-color: rgb(245, 245, 246);
        cursor: pointer;
    }
`;

export default LearningActiviesStyle;